import { useQuery } from '@tanstack/react-query';
import * as impersonationService from '../../services/impersonation.service';

export function useImpersonatableUsers(enabled: boolean = true) {
  return useQuery({
    queryKey: ['impersonatable-users'],
    queryFn: impersonationService.getImpersonatableUsers,
    enabled,
    staleTime: 1000 * 60 * 5, // 5 min
  });
}

export function usePermissions(enabled: boolean = true) {
  return useQuery({
    queryKey: ['permissions'],
    queryFn: impersonationService.getPermissions,
    enabled,
    staleTime: 1000 * 60 * 5, // 5 min
  });
}
